import aquarius from "@/assets/img/compatibility/zodiac/aquarius.svg"
import aries from "@/assets/img/compatibility/zodiac/aries.svg"
import cancer from "@/assets/img/compatibility/zodiac/cancer.svg"
import capricorn from "@/assets/img/compatibility/zodiac/capricorn.svg"
import gemini from "@/assets/img/compatibility/zodiac/gemini.svg"
import leo from "@/assets/img/compatibility/zodiac/leo.svg"
import libra from "@/assets/img/compatibility/zodiac/libra.svg"
import pisces from "@/assets/img/compatibility/zodiac/pisces.svg"
import sagittarius from "@/assets/img/compatibility/zodiac/sagittarius.svg"
import scorpio from "@/assets/img/compatibility/zodiac/scorpio.svg"
import taurus from "@/assets/img/compatibility/zodiac/taurus.svg"
import virgo from "@/assets/img/compatibility/zodiac/virgo.svg"

export type ZodiacSign =
  | "aries"
  | "taurus"
  | "gemini"
  | "cancer"
  | "leo"
  | "virgo"
  | "libra"
  | "scorpio"
  | "sagittarius"
  | "capricorn"
  | "aquarius"
  | "pisces"

/** Last (month, day) each sign covers, walking the year from Capricorn. */
const RANGES: { sign: ZodiacSign; until: [number, number] }[] = [
  { sign: "capricorn", until: [1, 19] },
  { sign: "aquarius", until: [2, 18] },
  { sign: "pisces", until: [3, 20] },
  { sign: "aries", until: [4, 19] },
  { sign: "taurus", until: [5, 20] },
  { sign: "gemini", until: [6, 20] },
  { sign: "cancer", until: [7, 22] },
  { sign: "leo", until: [8, 22] },
  { sign: "virgo", until: [9, 22] },
  { sign: "libra", until: [10, 22] },
  { sign: "scorpio", until: [11, 21] },
  { sign: "sagittarius", until: [12, 21] },
]

/** White line-glyph asset per sign (exported from the Figma Sign_Compatibility set). */
export const SIGN_GLYPH: Record<ZodiacSign, string> = {
  aries,
  taurus,
  gemini,
  cancer,
  leo,
  virgo,
  libra,
  scorpio,
  sagittarius,
  capricorn,
  aquarius,
  pisces,
}

export const SIGN_LABEL: Record<ZodiacSign, string> = {
  aries: "Aries",
  taurus: "Taurus",
  gemini: "Gemini",
  cancer: "Cancer",
  leo: "Leo",
  virgo: "Virgo",
  libra: "Libra",
  scorpio: "Scorpio",
  sagittarius: "Sagittarius",
  capricorn: "Capricorn",
  aquarius: "Aquarius",
  pisces: "Pisces",
}

/** Zodiac sign for an ISO date string (`YYYY-MM-DD`). Falls back to Leo. */
export function signFromDate(date?: string): ZodiacSign {
  if (!date) return "leo"
  const [, month, day] = date.split("-").map(Number)
  if (!month || !day) return "leo"
  const found = RANGES.find(({ until }) => month < until[0] || (month === until[0] && day <= until[1]))
  return found ? found.sign : "capricorn"
}
